import { Box, List, ListItem, ListItemText, Button } from '@mui/material';

import dayjs from 'dayjs';
import weekOfYear from 'dayjs/plugin/weekOfYear';
import quarterOfYear from 'dayjs/plugin/quarterOfYear';

dayjs.extend(weekOfYear);
dayjs.extend(quarterOfYear);

const CustomActionBar = ({ className, handleValueChange }) => {
    const setDateRange = (start, end) => {
        const from = start?.format('YYYY-MM-DDTHH:mm:ss') ?? null;
        const to = end?.format('YYYY-MM-DDTHH:mm:ss') ?? null;
        const value = { from:from, to:to };

        handleValueChange(value);
    };

    const getToday = () => {
        const start = dayjs().startOf('day');
        const end = dayjs().endOf('day');
        setDateRange(start, end);
    };

    const getTomorrow = () => {
        const start = dayjs().add(1, 'day').startOf('day');
        const end = dayjs().add(1, 'day').endOf('day');
        setDateRange(start, end);
    };

    const getYesterday = () => {
        const start = dayjs().subtract(1, 'day').startOf('day');
        const end = dayjs().subtract(1, 'day').endOf('day');
        setDateRange(start, end);
    };

    const getCurrentWeek = () => {
        const today = dayjs();
        const start = dayjs().startOf('week');
        const end = today;
        setDateRange(start, end);
    };

    const getThisWeek = () => {
        const start = dayjs().startOf('week');
        const end = dayjs().endOf('week');
        setDateRange(start, end);
    };

    const getLastWeek = () => {
        const start = dayjs().subtract(1, 'week').startOf('week');
        const end = dayjs().subtract(1, 'week').endOf('week');
        setDateRange(start, end);
    };

    const getCurrentMonth = () => {
        const today = dayjs();
        const start = dayjs().startOf('month');
        const end = today;
        setDateRange(start, end);
    };

    const getThisMonth = () => {
        const start = dayjs().startOf('month');
        const end = dayjs().endOf('month');
        setDateRange(start, end);
    };

    const getLastMonth = () => {
        const start = dayjs().subtract(1, 'month').startOf('month');
        const end = dayjs().subtract(1, 'month').endOf('month');
        setDateRange(start, end);
    };

    const getLast12Months = () => {
        const start = dayjs().subtract(12, 'month').add(1, 'day').startOf('day');
        const end = dayjs().endOf('day');
        setDateRange(start, end);
    };

    const getCurrentQuarter = () => {
        const today = dayjs();
        const start = dayjs().startOf('quarter');
        const end = today;
        setDateRange(start, end);
    };

    const getThisQuarter = () => {
        const start = dayjs().startOf('quarter');
        const end = dayjs().endOf('quarter');
        setDateRange(start, end);
    };

    const getLastQuarter = () => {
        const start = dayjs().subtract(1, 'quarter').startOf('quarter');
        const end = dayjs().subtract(1, 'quarter').endOf('quarter');
        setDateRange(start, end);
    };

    const getCurrentYear = () => {
        const today = dayjs();
        const start = dayjs().startOf('year');
        const end = today;
        setDateRange(start, end);
    };

    const getThisYear = () => {
        const start = dayjs().startOf('year');
        const end = dayjs().endOf('year');
        setDateRange(start, end);
    };

    const getLastYear = () => {
        const start = dayjs().subtract(1, 'year').startOf('year');
        const end = dayjs().subtract(1, 'year').endOf('year');
        setDateRange(start, end);
    };

    const getNoFilter = () => {
        const start = dayjs().set('year', 2000).startOf('year');
        const end = dayjs().set('year', 2100).endOf('year');
        setDateRange(start, end);
    };


    return (
        <Box className={className+" mtska-container"}>
            <Box className={"mtska-listscroller"}>
                <List dense>
                    <ListItem className="mtska-listsectiontitle">Days</ListItem>
                    <ListItem className="active" onClick={getToday}>
                        <ListItemText primary="Today" />
                    </ListItem>
                    <ListItem className="active" onClick={getTomorrow}>
                        <ListItemText primary="Tomorrow" />
                    </ListItem>
                    <ListItem className="active" onClick={getYesterday}>
                        <ListItemText primary="Yesterday" />
                    </ListItem>

                    <ListItem className="mtska-listsectiontitle">Weeks</ListItem>
                    <ListItem className="active" onClick={getCurrentWeek}>
                        <ListItemText primary="Current Week" />
                    </ListItem>
                    <ListItem className="active" onClick={getThisWeek}>
                        <ListItemText primary="This Week" />
                    </ListItem>
                    <ListItem className="active" onClick={getLastWeek}>
                        <ListItemText primary="Last Week" />
                    </ListItem>

                    <ListItem className="mtska-listsectiontitle">Months</ListItem>
                    <ListItem className="active" onClick={getCurrentMonth}>
                        <ListItemText primary="Current Month" />
                    </ListItem>
                    <ListItem className="active" onClick={getThisMonth}>
                        <ListItemText primary="This Month" />
                    </ListItem>
                    <ListItem className="active" onClick={getLastMonth}>
                        <ListItemText primary="Last Month" />
                    </ListItem>
                    <ListItem className="active" onClick={getLast12Months}>
                        <ListItemText primary="Last 12 Months" />
                    </ListItem>

                    <ListItem className="mtska-listsectiontitle">Quarters</ListItem>
                    <ListItem className="active" onClick={getCurrentQuarter}>
                        <ListItemText primary="Current Quarter" />
                    </ListItem>
                    <ListItem className="active" onClick={getThisQuarter}>
                        <ListItemText primary="This Quarter" />
                    </ListItem>
                    <ListItem className="active" onClick={getLastQuarter}>
                        <ListItemText primary="Last Quarter" />
                    </ListItem>

                    <ListItem className="mtska-listsectiontitle">Years</ListItem>
                    <ListItem className="active" onClick={getCurrentYear}>
                        <ListItemText primary="Current Year" />
                    </ListItem>
                    <ListItem className="active" onClick={getThisYear}>
                        <ListItemText primary="This Year" />
                    </ListItem>
                    <ListItem className="active" onClick={getLastYear}>
                        <ListItemText primary="Last Year" />
                    </ListItem>

                    <ListItem className="mtska-listsectiontitle">General</ListItem>
                    <ListItem className="active" onClick={getNoFilter}>
                        <ListItemText primary="No filter" />
                    </ListItem>
                </List>
            </Box>
            {/* <Box className={"mtska-actioncontainer"}>
                <Button onClick={onAccept}>OK</Button>
                <Button onClick={onCancel}>Cancel</Button>
                <Button onClick={onClear}>Clear</Button>
            </Box> */}
        </Box>
    );
};

export default CustomActionBar;